import { Button } from '@ps/isp-web-component-library';
import { CashierPath } from '@ps/web-pam-types';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useNavigate, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';

import { TXTWCL_Deposit_Funds } from './DepositButton.messages.json';

const DepositButton: React.FC = () => {
  const navigate = useNavigate();
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(TXTWCL_Deposit_Funds);

  return (
    <Button
      onClick={() => {
        buttonPressed({ buttonName });
        navigate(CashierPath.Deposit);
      }}
      size="medium"
    >
      <Translation {...TXTWCL_Deposit_Funds} />
    </Button>
  );
};

export default DepositButton;
